/**
 * Локальное состояние фильтров страницы клиентов (не Redux orders).
 */
export interface ICustomersFilterState {
  first_name: string
  last_name: string
  phone: string
  email: string
  city: string | null
  pizzeria_id: number | null
}

export const DEFAULT_CUSTOMERS_FILTER: ICustomersFilterState = {
  first_name: '',
  last_name: '',
  phone: '',
  email: '',
  city: null,
  pizzeria_id: null,
}
